import { EMAIL_MAX_WIDTH } from "./constants";

// Constrain images to 600px email body width before upload
export function resizeImageForEmail(file) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(img.src);
      if (img.width <= EMAIL_MAX_WIDTH) {
        resolve(file);
        return;
      }
      const scale = EMAIL_MAX_WIDTH / img.width;
      const canvas = document.createElement("canvas");
      canvas.width = EMAIL_MAX_WIDTH;
      canvas.height = Math.round(img.height * scale);
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        (blob) => resolve(new File([blob], file.name, { type: file.type })),
        file.type,
        0.9,
      );
    };
    img.onerror = () => resolve(file);
    img.src = URL.createObjectURL(file);
  });
}
